import React from "react";
import * as styles from "./OneThirdSummaryDisplay.module.css";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import {
  SummaryPod,
  SummaryPodProps,
} from "../../elements/SummaryPod/SummaryPod";
import { Equals } from "../../elements/Equals/equals";
import { tileLayouts } from "./index";

interface Props extends ComponentProps, ComponentWidth {
  summaries: SummaryPodProps[];
  tileLayout: tileLayouts;
  showEquals?: boolean;
  displayImages?: boolean;
  summaryAlignment?: "by_title" | "by_link";
  animate?: boolean;
}

export const OneThirdSummaryDisplay: React.FC<Props> = ({
  summaries,
  width,
  showEquals,
  tileLayout,
  displayImages,
  animate = true,
  summaryAlignment,
  ...props
}) => {
  if (!summaries) return null;
  let sectionWidthStyles = styles.summaries;

  if (width === "contained") {
    sectionWidthStyles += ` ${styles.contained}`;
  }

  if (summaries?.length > 2 && tileLayout !== "quarters") {
    sectionWidthStyles += ` ${styles.spaceAround}`;
  }

  if (summaries?.length === 2 && tileLayout !== "quarters") {
    sectionWidthStyles += ` ${styles.largeGap}`;
  }

  if (tileLayout === "quarters") {
    sectionWidthStyles += ` ${styles.quarters}`;
  }

  if (!displayImages) {
    sectionWidthStyles += ` ${styles.tallPadding}`;
  }

  const renderSummaries = () => {
    return summaries.map((tile, idx) => {
      return (
        <SummaryPod
          key={`summary-${idx}`}
          {...tile}
          displayImages={displayImages}
          animate={animate}
          summaryAlignment={summaryAlignment}
        />
      );
    });
  };

  return (
    <SectionWrapper {...props}>
      <div className={styles.container}>
        {showEquals && <Equals className={styles.equals} />}
        <div
          className={sectionWidthStyles}
          data-kontent-element-codename="content_tiles"
        >
          {renderSummaries()}
        </div>
      </div>
    </SectionWrapper>
  );
};
